import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import CheckoutForm from './CheckoutForm';

const stripePromise = loadStripe('pk_test_51QSDH5KTg1ZV8x5JFn9kvO1x9DVTqGZnzcP7xcjQQ1eVozXigs8PhPfIYpqmTltLXbzD8bNZ4G1dR8tIsZBHyDwd00bZklztEP'); // Substitua pela sua chave pública do Stripe
interface form {
    planType: string;
    
  }
const StripeSubscription = ({planType}:form) => {
    return (
        <Elements stripe={stripePromise}>
            <CheckoutForm planType={planType} />
        </Elements>
    );
};

export default StripeSubscription;